import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

const initialState = {};

const techModelSlice = createSlice({
  name: "techModel",
  initialState,
  reducers: {
    setTechModel(state, action) {
      state.techModel = action.payload;
    }
  }
});

const { actions, reducer } = techModelSlice;

export const { setTechModel } = actions;

export const setTechModelAction = (data) => async (dispatch) => {
  dispatch(setTechModel(data));
};

export default reducer;
